import React, { useState } from 'react'
import { Box, ListSubheader, MenuItem, TextField } from '@mui/material'
import { DatePickerSeeker } from '@ui-seeker/core'

import { dsColorNew } from '@palette'
import { FieldNote } from '@components'
import { toIso } from '../../../@services/dates'
import { DATE_WHEN, MAX_IN_DAYS, WEEK_WHEN, pickupNote, whenLabel } from '../@services/pickup'


const sub = text => <ListSubheader key={text} sx={{ fontSize: 11, fontWeight: 600, letterSpacing: 0.6, textTransform: 'uppercase', color: dsColorNew.textSubtle, lineHeight: '32px' }}>{text}</ListSubheader>

/**
 * "Pick-up date" / "Pick-up week" (CU-869fmjzrg UX § 2): relative options that the link and the remembered view keep
 * relative ("Next Saturday", "In N days", "Next week"…) and a fixed one with the date picker. Under it, the resolved
 * date(s) and how far they are (`pickupDates` = what the server resolved).
 */
export default function PickupField({ view, pickupDates, today, onChange }) {
	const [picking, setPicking] = useState(false)
	const isWeek = view.pick === 'week'
	const options = isWeek ? WEEK_WHEN : DATE_WHEN

	const items = [sub('Relative — the link keeps it relative')]
	Object.entries(options).filter(([k]) => k !== 'fixed').forEach(([k, label]) => items.push(<MenuItem key={k} value={k} sx={{ fontSize: 14 }}>{label}{k === 'inN' ? '…' : ''}</MenuItem>))
	items.push(sub(isWeek ? 'Fixed week — pick any day of it' : 'Fixed'))
	items.push(<MenuItem key="fixed" value="fixed" sx={{ fontSize: 14 }}>{isWeek ? 'Fixed week…' : 'Fixed date…'}</MenuItem>)

	return <Box>
		<TextField
			select size="small" fullWidth label={isWeek ? 'Pick-up week' : 'Pick-up date'} value={view.when}
			SelectProps={{ renderValue: () => whenLabel(view), MenuProps: { PaperProps: { sx: { minWidth: 300 } } } }}
			onChange={e => {
				const when = e.target.value
				if (when === 'fixed') { setPicking(true); return }
				onChange({ when, n: when === 'inN' ? (Number.isInteger(view.n) ? view.n : 14) : null, date: null })
			}}
		>{items}</TextField>
		{view.when === 'inN' && <TextField size="small" type="number" label="Days from today" value={view.n ?? ''} sx={{ mt: 1, width: '100%' }}
			inputProps={{ min: 0, max: MAX_IN_DAYS }}
			onChange={e => {
				const n = Number(e.target.value)
				if (Number.isInteger(n) && n >= 0 && n <= MAX_IN_DAYS) onChange({ when: 'inN', n, date: null })
			}}/>}
		{(picking || view.when === 'fixed') && <Box sx={{ mt: 1 }}>
			<DatePickerSeeker label={isWeek ? 'Any day of the week' : 'Pick-up date'} shouldDisableDate={() => false}
				value={view.date ? new Date(`${view.date}T00:00:00`) : null}
				onChange={d => {
					if (!(d instanceof Date) || Number.isNaN(d.getTime())) return
					setPicking(false)
					onChange({ when: 'fixed', n: null, date: toIso(d) })
				}}/>
		</Box>}
		<FieldNote>{pickupNote(view, pickupDates, today)}</FieldNote>
	</Box>
}
